module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Card', [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(" Tambah Pembayaran ")]), _vm._v(" "), _c('Form', {
    attrs: {
      "label-width": 120
    }
  }, [(_vm.paymentGiroId) ? _c('Card', {
    staticStyle: {
      "width": "50%"
    }
  }, [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Giro Info")]), _vm._v(" "), _c('Button', {
    attrs: {
      "slot": "extra",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.goToPaymentGiroList()
      }
    },
    slot: "extra"
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.finishLoading) ? [_c('Row', {
    staticClass: "code-row-bg",
    attrs: {
      "type": "flex",
      "justify": "center",
      "align": "middle"
    }
  }, [_c('Col', {
    attrs: {
      "span": "10"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm._f("dateFormatted")(_vm.paymentGiro.transactionDate)) + "\n                            "), _c('h5', [_vm._v(_vm._s(_vm.paymentGiro.bankAccountName))])]), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "span": "12",
      "offset": "2"
    }
  }, [_c('Tag', {
    attrs: {
      "type": "border",
      "color": "blue"
    }
  }, [_vm._v(" " + _vm._s(_vm._f("numberFormatted")(_vm.paymentGiro.amount)) + " ")])], 1)], 1)] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Tgl Pembayaran"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "110px"
    },
    attrs: {
      "type": "date",
      "placeholder": "",
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.paymentDate),
      callback: function($$v) {
        _vm.paymentDate = $$v
      },
      expression: "paymentDate"
    }
  })], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "2"
    }
  }, [_c('Select', {
    attrs: {
      "disabled": "",
      "placeholder": "Branchcode"
    },
    on: {
      "on-change": _vm.setMarkingCode
    },
    model: {
      value: (_vm.searchSelectSubbranch),
      callback: function($$v) {
        _vm.searchSelectSubbranch = $$v
      },
      expression: "searchSelectSubbranch"
    }
  }, _vm._l((_vm.subbranchs), function(subbranch, idx) {
    return _c('Option', {
      key: idx,
      attrs: {
        "value": subbranch.subbranchcode
      }
    }, [_vm._v("\n                                " + _vm._s(subbranch.subbranchname) + "\n                            ")])
  }), 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "1"
    }
  }, [_vm._v(" \n                    ")]), _vm._v(" "), _c('Col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != ''),
      expression: "paymentDate !=''"
    }],
    attrs: {
      "span": "3"
    }
  }, [_c('i-switch', {
    attrs: {
      "size": "large",
      "disabled": ""
    },
    model: {
      value: (_vm.isGroup),
      callback: function($$v) {
        _vm.isGroup = $$v
      },
      expression: "isGroup"
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("Group")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("Mark")])])], 1), _vm._v(" "), _c('Col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != '' && _vm.isGroup == false && _vm.paymentGiroId && _vm.paymentGiroMarking),
      expression: "paymentDate !='' && isGroup == false && paymentGiroId && paymentGiroMarking"
    }],
    attrs: {
      "span": "5"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.paymentGiroMarking),
      callback: function($$v) {
        _vm.paymentGiroMarking = $$v
      },
      expression: "paymentGiroMarking"
    }
  })], 1), _vm._v(" "), _c('Col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != '' && _vm.isGroup && _vm.paymentGiroId && _vm.paymentGiroMarkingGroup),
      expression: "paymentDate !='' && isGroup && paymentGiroId && paymentGiroMarkingGroup"
    }],
    attrs: {
      "span": "5"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.paymentGiroMarkingGroup),
      callback: function($$v) {
        _vm.paymentGiroMarkingGroup = $$v
      },
      expression: "paymentGiroMarkingGroup"
    }
  })], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "1",
      "offset": "1"
    }
  }, [_c('Spin', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingGetPayment),
      expression: "loadingGetPayment"
    }],
    attrs: {
      "size": "large"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != '' && _vm.markingIdSelected != '' && _vm.invoiceDues.length > 0),
      expression: "paymentDate !='' && markingIdSelected != '' && invoiceDues.length > 0 "
    }],
    attrs: {
      "label": "Keterangan"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "700px",
      "height": "100px"
    },
    attrs: {
      "type": "textarea",
      "rows": 4
    },
    model: {
      value: (_vm.description),
      callback: function($$v) {
        _vm.description = $$v
      },
      expression: "description"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != '' && _vm.markingIdSelected != '' && _vm.depositRemaining != 0),
      expression: "paymentDate != '' && markingIdSelected != '' && depositRemaining != 0"
    }],
    attrs: {
      "label": "Total Deposit"
    }
  }, [_c('Alert', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "type": "warning",
      "show-icon": ""
    }
  }, [_vm._v(" " + _vm._s(_vm._f("currency")(_vm.depositRemaining)) + "\n                ")]), _vm._v(" "), (_vm.totalUseDepositAmount > 0 && _vm.totalUseDepositAmount > _vm.depositRemaining) ? _c('font', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Terpakai\n                    " + _vm._s(_vm._f("currency")(_vm.totalUseDepositAmount)) + " - LEBIH\n                ")]) : _vm._e(), _vm._v(" "), (_vm.totalUseDepositAmount > 0 && _vm.totalUseDepositAmount <= _vm.depositRemaining) ? _c('font', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("\n                    Terpakai: " + _vm._s(_vm._f("currency")(_vm.totalUseDepositAmount)) + ", Sisa: " + _vm._s(_vm._f("currency")((_vm.depositRemaining -
    _vm.totalUseDepositAmount))) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Klaim",
      "prop": "claim"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "placeholder": "Masukan Klaim yang sesuai dengan Mutasi",
      "filterable": "",
      "multiple": "",
      "disabled": _vm.optionClaims.length === 0
    },
    model: {
      value: (_vm.claims),
      callback: function($$v) {
        _vm.claims = $$v
      },
      expression: "claims"
    }
  }, _vm._l((_vm.optionClaims), function(option, index) {
    return _c('Option', {
      key: index,
      attrs: {
        "value": option.value
      }
    }, [_vm._v("\n                        " + _vm._s(option.label))])
  }), 1), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "info",
      "icon": "ios-refresh",
      "loading": _vm.loadingGetClaims
    },
    on: {
      "click": _vm.getClaims
    }
  }, [_vm._v("Refresh Klaim")])], 1), _vm._v(" "), _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != '' && _vm.markingIdSelected != '' && _vm.invoiceDues.length > 0 && _vm.depositMutasiRemaining),
      expression: "paymentDate != '' && markingIdSelected != '' && invoiceDues.length > 0 && depositMutasiRemaining"
    }],
    attrs: {
      "label": "Total Mutasi Deposit"
    }
  }, [_c('Alert', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "type": "warning",
      "show-icon": ""
    }
  }, [_vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.depositMutasiRemaining)) + "\n                ")]), _vm._v(" "), (_vm.totalUseDepositMutasi > 0 && _vm.totalUseDepositMutasi > _vm.depositMutasiRemaining) ? _c('font', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n                    Terpakai\n                    " + _vm._s(_vm._f("currency")(_vm.totalUseDepositMutasi)) + " - LEBIH\n                ")]) : _vm._e(), _vm._v(" "), (_vm.totalUseDepositMutasi > 0 && _vm.totalUseDepositMutasi <= _vm.depositMutasiRemaining) ? _c('font', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("\n                    Terpakai: " + _vm._s(_vm._f("currency")(_vm.totalUseDepositMutasi)) + ", Sisa: " + _vm._s(_vm._f("currency")((_vm.depositMutasiRemaining -
    _vm.totalUseDepositMutasi))) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != '' && _vm.markingIdSelected != '' && _vm.depositRemaining != 0),
      expression: "paymentDate !='' && markingIdSelected != '' && depositRemaining != 0 "
    }],
    attrs: {
      "label": "Deposit"
    }
  }, [_c('Alert', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "warning",
      "show-icon": ""
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.depositRemaining)) + "\n                ")]), _vm._v(" "), (_vm.totalUseDepositAmount > 0 && _vm.totalUseDepositAmount > _vm.depositRemaining) ? _c('font', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Terpakai " + _vm._s(_vm._f("currency")(_vm.totalUseDepositAmount)) + " - LEBIH")]) : _vm._e(), _vm._v(" "), (_vm.totalUseDepositAmount > 0 && _vm.totalUseDepositAmount <= _vm.depositRemaining) ? _c('font', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("\n                        Terpakai: " + _vm._s(_vm._f("currency")(_vm.totalUseDepositAmount)) + ", Sisa: " + _vm._s(_vm._f("currency")((_vm.depositRemaining - _vm.totalUseDepositAmount))) + "\n                    ")]) : _vm._e()], 1), _vm._v(" "), _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != '' && _vm.markingIdSelected != '' && _vm.invoiceDues.length > 0),
      expression: "paymentDate !='' && markingIdSelected != '' && invoiceDues.length > 0 "
    }],
    attrs: {
      "label": "Uang Diterima"
    }
  }, [_c('money', _vm._b({
    staticClass: "ivu-input right",
    staticStyle: {
      "width": "150px"
    },
    model: {
      value: (_vm.amountReceived),
      callback: function($$v) {
        _vm.amountReceived = $$v
      },
      expression: "amountReceived"
    }
  }, 'money', _vm.money, false)), _vm._v(" "), _c('font', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.amountResidue != 0),
      expression: "amountResidue != 0"
    }],
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v("\n                        Selisih   " + _vm._s(_vm._f("currency")(_vm.amountResidue)) + "\n                    ")])], 1), _vm._v(" "), _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != '' && _vm.markingIdSelected != '' && _vm.invoiceDues.length > 0 && _vm.paymentGiroId),
      expression: "paymentDate !='' && markingIdSelected != '' && invoiceDues.length > 0 && paymentGiroId "
    }],
    attrs: {
      "label": "Uang Potongan"
    }
  }, [_c('money', _vm._b({
    staticClass: "ivu-input right",
    staticStyle: {
      "width": "150px"
    },
    model: {
      value: (_vm.discountReceived),
      callback: function($$v) {
        _vm.discountReceived = $$v
      },
      expression: "discountReceived"
    }
  }, 'money', _vm.money, false))], 1), _vm._v(" "), _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != '' && _vm.markingIdSelected != '' && _vm.invoiceDues.length > 0 && _vm.paymentGiroId == null),
      expression: "paymentDate !='' && markingIdSelected != '' && invoiceDues.length > 0 && paymentGiroId == null"
    }],
    attrs: {
      "label": "Kategori"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.category),
      expression: "category"
    }],
    attrs: {
      "type": "radio",
      "id": "payment",
      "value": "pay"
    },
    domProps: {
      "checked": _vm._q(_vm.category, "pay")
    },
    on: {
      "change": function($event) {
        _vm.category = "pay"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "payment"
    }
  }, [_vm._v("Pembayaran")]), _vm._v("    \n                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.category),
      expression: "category"
    }],
    attrs: {
      "type": "radio",
      "id": "discount",
      "value": "disc"
    },
    domProps: {
      "checked": _vm._q(_vm.category, "disc")
    },
    on: {
      "change": function($event) {
        _vm.category = "disc"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "discount"
    }
  }, [_vm._v("Potongan")])]), _vm._v(" "), _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDate != '' && _vm.markingIdSelected != '' && _vm.invoiceDues.length > 0 && _vm.paymentGiroId),
      expression: "paymentDate !='' && markingIdSelected != '' && invoiceDues.length > 0 && paymentGiroId"
    }],
    attrs: {
      "label": "Kategori"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.category),
      expression: "category"
    }],
    attrs: {
      "type": "radio",
      "id": "payment",
      "value": "pay"
    },
    domProps: {
      "checked": _vm._q(_vm.category, "pay")
    },
    on: {
      "change": function($event) {
        _vm.category = "pay"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "payment"
    }
  }, [_vm._v("Pembayaran")]), _vm._v("    \n            ")]), _vm._v(" "), _c('Alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.depositAmount != 0),
      expression: "depositAmount != 0"
    }],
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "warning",
      "show-icon": ""
    }
  }, [_vm._v("Kelebihan : " + _vm._s(_vm._f("currency")(_vm.depositAmount)))]), _vm._v(" "), _c('Alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.depositAmount != 0 && _vm.category == 'disc'),
      expression: "depositAmount != 0 && category == 'disc'"
    }],
    staticStyle: {
      "width": "700px"
    },
    attrs: {
      "type": "error",
      "show-icon": ""
    }
  }, [_vm._v(" Tidak dapat melanjutkan proses pembayaran jika terdapat Kelebihan pada Kategori Potongan.")]), _vm._v(" "), _c('Alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.depositAmount > _vm.paymentGiroAmount && _vm.paymentGiroId),
      expression: "depositAmount > paymentGiroAmount && paymentGiroId"
    }],
    staticStyle: {
      "width": "700px"
    },
    attrs: {
      "type": "error",
      "show-icon": ""
    }
  }, [_vm._v(" Tidak dapat melanjutkan proses pembayaran jika Alokasi Pembayaran lebih besar dari Mutasi.")])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('Card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.invoiceDues.length > 0 && _vm.receivableGroup == ''),
      expression: "this.invoiceDues.length > 0 && receivableGroup == ''"
    }]
  }, [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(" Daftar Invoice ")]), _vm._v(" "), _c('Row', {
    staticClass: "code-row-bg",
    attrs: {
      "type": "flex"
    }
  }, [
    [(_vm.isGroup) ? _c('Col', {
      attrs: {
        "span": "2"
      }
    }, [_vm._v(" Marking ")]) : _vm._e(), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "3"
      }
    }, [_vm._v(" Tgl Bongkar ")]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "7"
      }
    }, [_vm._v(" Keterangan ")]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "3"
      }
    }, [_vm._v(" Total ")]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "3"
      }
    }, [_vm._v(" Sisa ")]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "5"
      }
    }, [_vm._v(" Alokasi Pembayaran ")]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "3"
      }
    }, [_vm._v(" Potongan ")])]
  ], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.invoiceDues), function(invoiceDue) {
    return _c('div', {
      key: invoiceDue.id
    }, [_c('cInvoicePayment', {
      attrs: {
        "invoiceDue": invoiceDue,
        "depositRemaining": _vm.depositRemaining,
        "depositMutasiRemaining": _vm.depositMutasiRemaining,
        "paymentGiroId": _vm.paymentGiroId,
        "paymentGiroAmount": _vm.paymentGiroAmount
      },
      on: {
        "setAllocateAmount": _vm.setAllocateAmount
      }
    }), _vm._v(" "), _c('br')], 1)
  })], 2), _vm._v(" "), (_vm.receivableGroup != '') ? _c('Card', [_c('Tabs', {
    attrs: {
      "animated": false
    }
  }, _vm._l((_vm.receivableGroup), function(marking) {
    return _c('TabPane', {
      key: marking.markingheadercode,
      attrs: {
        "label": marking.markingheadercode
      }
    }, [_c('p', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(" Daftar Invoice ")]), _vm._v(" "), _c('Row', {
      staticClass: "code-row-bg ivu-row-flex-space-between",
      attrs: {
        "type": "flex"
      }
    }, [
      [_c('Col', {
        attrs: {
          "span": "2"
        }
      }, [_vm._v(" Tgl Bongkar ")]), _vm._v(" "), _c('Col', {
        attrs: {
          "span": "6"
        }
      }, [_vm._v(" Keterangan ")]), _vm._v(" "), _c('Col', {
        attrs: {
          "span": "3"
        }
      }, [_vm._v(" Total ")]), _vm._v(" "), _c('Col', {
        attrs: {
          "span": "3"
        }
      }, [_vm._v(" Sisa ")]), _vm._v(" "), _c('Col', {
        attrs: {
          "span": "3"
        }
      }, [_vm._v(" Alokasi Pembayaran ")]), _vm._v(" "), _c('Col', {
        attrs: {
          "span": "5"
        }
      }, [_vm._v(" Potongan ")])]
    ], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((marking.invoiceDue), function(invoiceDue) {
      return _c('div', {
        key: invoiceDue.id
      }, [_c('cInvoicePayment', {
        attrs: {
          "invoiceDue": invoiceDue,
          "depositRemaining": _vm.depositRemaining,
          "paymentGiroId": _vm.paymentGiroId,
          "paymentGiroAmount": _vm.paymentGiroAmount
        },
        on: {
          "setAllocateAmount": _vm.setAllocateAmount
        }
      }), _vm._v(" "), _c('br')], 1)
    })], 2)
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGroup == false),
      expression: "isGroup == false"
    }],
    staticClass: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.description != '' && _vm.category != '' && (((_vm.totalUseDepositAmount <= _vm.depositRemaining) || _vm.depositRemaining < 0) ||
        ((_vm.totalUseDepositMutasi <= _vm.depositMutasiRemaining) || _vm.depositMutasiRemaining < 0)) && _vm.paymentGiroId == null),
      expression: "description !='' && category != '' && (((totalUseDepositAmount <= depositRemaining) || depositRemaining < 0) ||\n          ((totalUseDepositMutasi <= depositMutasiRemaining) || depositMutasiRemaining < 0)) && paymentGiroId == null"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.loadingPost,
      "icon": "checkmark-round",
      "size": "small"
    },
    on: {
      "click": _vm.postPayment
    }
  }, [(!_vm.loadingPost && _vm.amountReceived + _vm.totalUseDepositAmount > 0) ? _c('span', [_vm._v("Bayar")]) : (!_vm.loadingPost && (_vm.amountReceived == 0)) ? _c('span', [_vm._v("Bayar Free")]) : _c('span', [_vm._v("Wait.....")])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGroup == false),
      expression: "isGroup == false"
    }],
    staticClass: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.description != '' && _vm.category != '' && (((_vm.totalUseDepositAmount <= _vm.depositRemaining) || _vm.depositRemaining < 0) ||
        ((_vm.totalUseDepositMutasi <= _vm.depositMutasiRemaining) || _vm.depositMutasiRemaining < 0)) && ((_vm.depositAmount == 0 && _vm.category == 'disc') || (_vm.depositAmount >= 0 && _vm.category == 'pay')) && ((_vm.paymentGiroId && _vm.depositAmount <= _vm.paymentGiroAmount) || _vm.paymentGiroId == null)),
      expression: "description !='' && category != '' && (((totalUseDepositAmount <= depositRemaining) || depositRemaining < 0) ||\n          ((totalUseDepositMutasi <= depositMutasiRemaining) || depositMutasiRemaining < 0)) && ((depositAmount == 0 && category == 'disc') || (depositAmount >= 0 && category == 'pay')) && ((paymentGiroId && depositAmount <= paymentGiroAmount) || paymentGiroId == null)"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.loadingPost,
      "icon": "checkmark-round",
      "size": "small"
    },
    on: {
      "click": _vm.postPaymentGiro
    }
  }, [(!_vm.loadingPost && _vm.amountReceived + _vm.totalUseDepositAmount + _vm.totalUseDepositMutasi > 0) ? _c('span', [_vm._v("Bayar")]) : (!_vm.loadingPost && (_vm.amountReceived == 0)) ? _c('span', [_vm._v("Bayar Free")]) : _c('span', [_vm._v("Wait.....")])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGroup),
      expression: "isGroup"
    }],
    staticClass: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.description != '' && _vm.category != '' && ((_vm.totalUseDepositAmount <= _vm.depositRemaining) || _vm.depositRemaining < 0)),
      expression: "description !='' && category != '' && ((totalUseDepositAmount <= depositRemaining) || depositRemaining < 0)"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.loadingPost,
      "icon": "checkmark-round",
      "size": "small"
    },
    on: {
      "click": _vm.postPaymentByGroup
    }
  }, [(!_vm.loadingPost && _vm.amountReceived + _vm.totalUseDepositAmount + _vm.totalUseDepositMutasi > 0) ? _c('span', [_vm._v("Bayar")]) : (!_vm.loadingPost && (_vm.amountReceived == 0)) ? _c('span', [_vm._v("Bayar Free")]) : _c('span', [_vm._v("Wait.....")])])], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "500px"
    },
    on: {
      "on-cancel": function($event) {
        _vm.depositType = ''
      }
    },
    model: {
      value: (_vm.modalConfirmDeposit),
      callback: function($$v) {
        _vm.modalConfirmDeposit = $$v
      },
      expression: "modalConfirmDeposit"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#2d8cf0",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Konfirmasi")])], 1), _vm._v("\n        Kelebihan "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.depositAmount)))]), _vm._v(" akan dijadikan sebagai :\n        "), _c('div', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('RadioGroup', {
    attrs: {
      "vertical": ""
    },
    model: {
      value: (_vm.depositType),
      callback: function($$v) {
        _vm.depositType = $$v
      },
      expression: "depositType"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "DEP"
    }
  }, [_c('span', [_vm._v("Deposit")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "PRF"
    }
  }, [_c('span', [_vm._v("Pendapatan")])])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGroup == false && _vm.paymentGiroId == null),
      expression: "isGroup == false && paymentGiroId == null"
    }],
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.depositType != ''),
      expression: "depositType != ''"
    }],
    attrs: {
      "type": "primary",
      "long": "",
      "loading": _vm.loadingPost
    },
    on: {
      "click": _vm.postPayment
    }
  }, [(!_vm.loadingPost) ? _c('span', [_vm._v("Bayar")]) : _c('span', [_vm._v("Wait.....")])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGroup == false && _vm.paymentGiroId),
      expression: "isGroup == false && paymentGiroId"
    }],
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.depositType != ''),
      expression: "depositType != ''"
    }],
    attrs: {
      "type": "primary",
      "long": "",
      "loading": _vm.loadingPost
    },
    on: {
      "click": _vm.postPaymentGiro
    }
  }, [(!_vm.loadingPost) ? _c('span', [_vm._v("Bayar")]) : _c('span', [_vm._v("Wait.....")])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGroup),
      expression: "isGroup"
    }],
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.depositType != ''),
      expression: "depositType != ''"
    }],
    attrs: {
      "type": "primary",
      "long": "",
      "loading": _vm.loadingPost
    },
    on: {
      "click": _vm.postPaymentByGroup
    }
  }, [(!_vm.loadingPost) ? _c('span', [_vm._v("Bayar")]) : _c('span', [_vm._v("Wait.....")])])], 1)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "500px"
    },
    model: {
      value: (_vm.modalConfirmAutoDeposit),
      callback: function($$v) {
        _vm.modalConfirmAutoDeposit = $$v
      },
      expression: "modalConfirmAutoDeposit"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#ffffff",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Konfirmasi")])], 1), _vm._v(" "), _c('p', [_vm._v("\n            Marking tidak memiliki piutang, apakah giro dengan Total : "), _c('b', [_vm._v(" Rp. " + _vm._s(_vm._f("currency")(_vm.paymentGiroAmount)) + " ")]), _vm._v("\n            ingin dijadikan sebagai "), _c('b', [_vm._v("Deposit")]), _vm._v(" ?\n        ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "error"
    },
    on: {
      "click": function($event) {
        _vm.modalConfirmAutoDeposit = false
      }
    }
  }, [_vm._v("Batalkan")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loadingPost
    },
    on: {
      "click": _vm.postReceivableAsDeposit
    }
  }, [(!_vm.loadingPost) ? _c('span', [_vm._v("Tambahkan")]) : _c('span', [_vm._v("Mohon tunggu...")])])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0882ca55","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/giro/GiroPaymentAdd.vue
// module id = 1774
// module chunks = 1